// extracted by mini-css-extract-plugin
export default {"newsletters":"Newsletters_newsletters__ASfui"};